export default class ClickOutSide {
  /**
   * display default image when the first time DOM is loaded
   * @param el 
   */
  inserted(el) {
  }

  /**
   * need reload image when update view model
   * @param el 
   * @param binding 
   * @param vnode 
   * @param oldVnode 
   */
  update(el, binding, vnode, oldVnode) {
  }

  /**
   * bind when created 
   * @param el 
   * @param binding 
   * @param vnode 
   */
  bind(el, binding, vnode) {
    el.event = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.event)
  }

  unbind(el){
    document.body.removeEventListener('click', el.event)
  }

}
